"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePassword = void 0;
const password_validator_1 = __importDefault(require("password-validator"));
exports.validatePassword = (password) => {
    var schema = new password_validator_1.default();
    // Add properties to it
    schema
        .is().min(8) // Minimum length 8
        .is().max(100) // Maximum length 100
        .has().uppercase() // Must have uppercase letters
        .has().lowercase() // Must have lowercase letters
        .has().digits(1) // Must have at least 2 digits
        .is().not().oneOf(['Passw0rd', 'Password123', 'pa$$w0rd']);
    return schema.validate(password);
};
//# sourceMappingURL=validatePassword.js.map